import { prefersReducedMotion } from '@theme/utilities';

/**
 * Adds `.scroll-reveal--in-view` to any `.scroll-reveal` element once it
 * scrolls into the viewport, then stops observing it. Section stylesheets
 * pause their own entrance `animation` by default and only resume it once
 * that class is present - this file just owns the trigger, not the timing
 * or easing of any individual animation.
 */
if (!prefersReducedMotion()) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal--in-view');
        observer.unobserve(entry.target);
      }
    },
    // threshold 0: tall sections (e.g. a long product grid) may never have 10% of
    // their height on screen at load, which left cards hidden until the user scrolled.
    { rootMargin: '0px 0px -10% 0px', threshold: 0 }
  );

  document.querySelectorAll('.scroll-reveal').forEach((element) => observer.observe(element));
}
